export { getButtonConfig } from './buttons';
export { getScoreMeterConfig } from './scoremeter';
export { colorGuide, colorPalette, mainColors, extend } from './colors';
export { typographyGuide, fontNameSpaces, FontVariant } from './typography';
export { SliderConfig, ThumbConfig } from './slider';

const enum PlunkProps {
    WIDTH = 3,
    ANGLE = 45,
}

export { PlunkProps };

export { FontOpacity } from './opacity';
